import {AppState} from '../reducers';
import {createFeatureSelector, createSelector} from '@ngrx/store';

// selectors

export const getCoreState = createFeatureSelector<AppState>('core');

export const getCustomerState = createSelector(
  getCoreState,
  (state: AppState) => {
    return state.login?.authorization?.Customer;
  }
);

export const getTokenState = createSelector(getCoreState, (state: AppState) => {
  // console.log(
  //   'gettoken',
  //   state.login?.authorization?.type,
  //   state.login?.authorization?.token,
  //   state.login?.guestToken
  // );
  return state.login?.authorization?.token
    ? state.login?.authorization?.token
    : state.login?.guestToken;
});
export const getSenderState = createSelector(
  getCoreState,
  (state: AppState) => {
    return state.login?.requester;
  }
);
export const getIsAuthenticated = createSelector(
  getCoreState,
  (state: AppState) => {
    return (
      state.login?.authorization.token !== undefined &&
      state.login?.authorization.type !== 5 &&
      state.login?.authorization.status
    );
  }
);
